import { render, staticRenderFns } from "./LotRequestWizard.vue?vue&type=template&id=72a64688&"
import script from "./LotRequestWizard.vue?vue&type=script&lang=js&"
export * from "./LotRequestWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports